/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApiOrganisationDataType {
    CONFIGURATION = 'CONFIGURATION',
    TRANSACTION = 'TRANSACTION',
    PERSON = 'PERSON'
}


export function instanceOfApiOrganisationDataType(value: any): boolean {
    for (const key in ApiOrganisationDataType) {
        if (Object.prototype.hasOwnProperty.call(ApiOrganisationDataType, key)) {
            if (ApiOrganisationDataType[key as keyof typeof ApiOrganisationDataType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ApiOrganisationDataTypeFromJSON(json: any): ApiOrganisationDataType {
    return ApiOrganisationDataTypeFromJSONTyped(json, false);
}

export function ApiOrganisationDataTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiOrganisationDataType {
    return json as ApiOrganisationDataType;
}

export function ApiOrganisationDataTypeToJSON(value?: ApiOrganisationDataType | null): any {
    return value as any;
}

export function ApiOrganisationDataTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ApiOrganisationDataType {
    return value as ApiOrganisationDataType;
}

